<template>
  <div id="childInfo">
    <v-form ref="childInfoForm">
      <v-container>
        <v-layout class="pr-4 pl-4 hidden-sm-and-up button-container">
          <v-flex xs12 sm12 md12 v-if="isFormDataChanged" class="pr-0 text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right hidden-xs-only">
            <div class="d-inline-flex" v-if="isFormDataChanged">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-layout wrap>
          <v-flex xs12>
            <div class="flex-row flex-top">
              <v-radio-group v-model="childDetails.child_type" label="1. Child Type" row @change="changedChildType()" class="ma-0 pa-0">
                <v-radio
                  v-for="(type, j) in childrenTypes"
                  :key="j"
                  :label="`${type.text}`"
                  :value="type.value"
                ></v-radio>
              </v-radio-group>
            </div>
          </v-flex>
          <v-flex xs12 sm4 v-if="childDetails.child_type !== 'Individual'" class="pt-0">
            <v-text-field v-model.trim="childDetails.name" :rules="form.child.fields.firstName.rules" label="Group Name"
            class="required" @input="isFormDataChanged = true"></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout wrap class="pb-2">
          <v-flex :class="{ 'flex-space-between': $vuetify.breakpoint.smAndUp }">
            <h5 class="font-weight-bold">2. Basic Information</h5>
            <!-- Add more child or remove -->
            <v-flex :class="{ 'flex-end': $vuetify.breakpoint.smAndUp }">
              <v-btn
                class="pf-btn-text-white pf-bg-green"
                @click="addChild"
              >
                Add Child
              </v-btn>
            </v-flex>
          </v-flex>

          <v-expansion-panel class="px-2 box-shadow-none" id="expansion-panel" v-model="panels" expand>
            <v-expansion-panel-content class="my-1 pf-bg-pink" v-for="(child, c) in childDetails.human" :key="c">
              <template v-slot:actions>
                <v-icon color="white">$vuetify.icons.expand</v-icon>
              </template>
              <template v-slot:header>
                <v-flex class="flex-start">
                  <v-icon color="white" v-if="c > 0" @click="removeChild(c)" class="mr-2" title="Remove" size="20">close</v-icon>
                  <h5 class="font-weight-medium pf-text-white">Child{{ (c > 0 || childDetails.human.length > 1) ? (' ' + (c + 1)) : '' }}<span class="font-weight-light">{{ child.first_name ? ': ' + child.first_name : '' }}</span></h5>
                </v-flex>
              </template>
              <v-card>
                <v-card-text class="px-2">
                  <!-- Tabs -->
                  <v-tabs v-model="dataTabsModel" slider-color="#019d8c" class="pf-tabs-teal pf-tab pf-width-100p">

                    <v-tab href="#tab-1">
                      Background Information
                      <v-icon class="pf-text-teal ml-1" size="20">account_circle</v-icon>
                    </v-tab>
                    <v-tab href="#tab-2" :disabled="!isBasicInfoCompleted(child)">
                      Disabilities & Risks
                      <v-icon class="pf-text-teal ml-1" size="20">warning</v-icon>
                    </v-tab>
                    <v-tab href="#tab-3">
                      Avatar
                      <v-icon class="pf-text-teal ml-1" size="20">image</v-icon>
                    </v-tab>

                    <v-tab-item value="tab-1">
                      <v-card flat>
                        <v-card-text>
                          <v-layout wrap class="my-3">
                            <v-flex xs12 sm4>
                              <v-text-field v-model.trim="child.first_name" :rules="[rules.required]" label="First Name"
                              class="required px-3" @input="changedData"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-text-field v-model.trim="child.middle_name" label="Middle Name"
                              class="px-3" @input="changedData"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-text-field v-model="child.last_name" label="Last Name" class="px-3" @input="changedData"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-text-field v-model="child.case_id" label="Case ID" class="px-3" @input="changedData"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-menu
                                :ref="`child${c}.birth_date`"
                                v-model="child.picker"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="dobFormatted[c]"
                                    label="Date of Birth"
                                    hint="MM/DD/YYYY"
                                    persistent-hint
                                    readonly 
                                    clearable
                                    prepend-icon="event"
                                    v-on="on"
                                    :rules="[rules.required]"
                                    class="required px-3"
                                    @blur="child.birth_date = parseDate(dobFormatted[c]); isFormDataChanged = true"
                                    @input="/* child.birth_date = formatDate(parseDate(child.birth_date)); */isFormDataChanged = true"
                                  ></v-text-field>
                                </template>
                                <v-date-picker color="#019d8c" :max="new Date().toISOString().substr(0, 10)" v-model="child.birth_date"
                                @input="child.picker = false">
                                </v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-select v-model="child.gender" label="Gender" :rules="[rules.required]" class="required px-3" :items="genders" @change="changedData"></v-select>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-select v-model="child.ethnicity" :rules="[rules.required]" :small-chips="child.ethnicity !== ''" :deletable-chips="child.ethnicity !== ''" label="Race" class="required px-3" :items="ethnicities" @change="changedData"></v-select>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-select v-model="child.education" :small-chips="child.education !== ''" :deletable-chips="child.education !== ''" label="Education" class="px-3" :items="educations" @change="changedData"></v-select>
                            </v-flex>
                            <v-flex xs12 sm4 class="flex-align-end">
                              <v-radio-group label="Legally Free" :rules="[v => typeof v !== 'undefined' || 'Please select an option']" v-model="child.additional_info.legally_free" row class="px-3">
                                <v-radio
                                  v-for="(type, j) in yesOrNo"
                                  :key="j"
                                  :label="`${type.text}`"
                                  :value="type.value"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-select v-model="child.additional_info.icwa" label="Does ICWA apply" class="px-3" :items="yesOrNo" @change="changedData"></v-select>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-select item-value="id" :rules="[rules.required]" item-text="name" v-model="child.additional_info.jurisdiction.state" label="State / territory of jurisdiction" class="required px-3" :items="states" @change="changedData"></v-select>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-text-field v-model="child.additional_info.jurisdiction.county" label="County of jurisdiction" class="px-3" @change="changedData"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-select v-model="child.additional_info.primary_language" label="Primary language" :rules="[rules.required]" class="required px-3" :items="languages" @change="changedData"></v-select>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-select v-model="child.additional_info.secondary_language" label="Secondary language" class="px-3" :items="languages" @change="changedData"></v-select>
                            </v-flex>
                            <v-flex xs12 sm4 class="flex-align-end">
                              <v-radio-group label="Are there significant relationships the child must maintain?" v-model="child.additional_info.keep_relationships" row class="px-3">
                                <v-radio
                                  v-for="(type, j) in yesOrNo"
                                  :key="j"
                                  :label="`${type.text}`"
                                  :value="type.value"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                            <v-flex xs12 sm4 v-if="child.additional_info.keep_relationships">
                              <v-text-field v-model.trim="child.additional_info.keep_relation_person" label="With whom child must maintain relationships"
                              class="px-3" @input="changedData"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-select v-model="child.additional_info.pets" label="Child’s pet allergies (select all that apply)" class="px-3" multiple small-chips deletable-chips :items="pets" @change="changedData"></v-select>
                            </v-flex>
                            <v-flex xs12 sm4 class="flex-align-end">
                              <v-radio-group label="Allergic to smoke?" v-model="child.additional_info.smoke_allergy" row class="px-3">
                                <v-radio
                                  v-for="(type, j) in yesOrNo"
                                  :key="j"
                                  :label="`${type.text}`"
                                  :value="type.value"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-select v-model="child.additional_info.pay_private_services" label="Will child's agency pay for private agency services" class="px-3" :items="[...['Check with child\'s worker'], ...yesOrNo]" @change="changedData"></v-select>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap class="my-3">
                            <v-flex xs12 sm4>
                              <v-textarea v-model.trim="child.additional_info.allergies" label="Allergies (food, medicine, etc.)"
                              class="px-3" @input="changedData"></v-textarea>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap class="my-3">
                            <v-flex xs12 sm4 class="flex-column flex-align-start px-3">
                              <label class="font-weight-regular pf-font-16">Adoption assistance eligibility:</label>
                              <template v-for="(eligibility, e) in eligibilities">
                                <v-checkbox :key="e" :value="eligibility" v-model="child.additional_info.assistance_eligibility" :label="eligibility" class="design-checkbox flex-center mt-1" color="teal"></v-checkbox>
                              </template>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap class="px-3 my-3">
                            <v-flex sm12>
                              <label class="font-weight-regular pf-font-16">About:</label>
                              <editor :options="editorOption" :content="aboutContent" :init="init" :api-key="config.tinymceEditorKey" v-model="child.additional_info.about" @input="changedData" />
                            </v-flex>
                          </v-layout>

                          <v-layout>
                            <v-flex class="button-container pr-0 text-xs-right hidden-xs-only">
                              <div class="d-inline-flex">
                                <v-btn class="pf-btn pf-btn-save" @click="changeDataTabs('tab-2')" :disabled="!isBasicInfoCompleted(child)">
                                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                                  <div>Continue</div>
                                </v-btn>
                              </div>
                            </v-flex>
                          </v-layout>

                        </v-card-text>
                      </v-card>
                    </v-tab-item>

                    <v-tab-item value="tab-2">
                      <v-card flat>
                        <v-card-text>
                          <v-flex class="flex-column flex-align-start px-3 grey--text text--darken-2 mb-3">
                            <h5 class="mt-3 mb-2 pf-font-16 font-weight-medium">Select only:</h5>
                            <span>1. Physical, developmental, and learning disabilities that are current (i.e. occurring in the last year or are ongoing) and have been diagnosed by a licensed provider</span>
                            <span>2. Behavioral challenges that a child is currently exhibiting</span>
                          </v-flex>
                          <v-flex class="flex-column flex-align-start px-3 grey--text text--darken-2 mb-4">
                            <h5 class="mt-3 mb-2 pf-font-16 font-weight-medium">Displaying disabilities:</h5>
                            <span>Full details on risk factors and disabilities are available to all child and family workers registered, and only available to registered families at your discretion.</span>
                          </v-flex>
                          <v-layout wrap class="my-3">
                            <v-flex xs12 class="px-3">
                              <div class="flex-column flex-align-start">
                                <v-radio-group :rules="[rules.required]" v-model="child.additional_info.disability.display" label="Access for registered families" class="required ma-0 pa-0">
                                  <v-radio
                                    v-for="(access, j) in disabilityAccess"
                                    :key="j"
                                    :label="`${access}`"
                                    :value="access"
                                  ></v-radio>
                                </v-radio-group>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm4 class="flex-column flex-align-start px-3">
                              <label class="font-weight-regular pf-font-16">Risk Factors</label>
                              <template v-for="(risk, e) in risks">
                                <v-checkbox :key="e" :value="risk" v-model="child.additional_info.disability.risks" :label="risk" class="design-checkbox flex-center mt-1" color="teal"></v-checkbox>
                              </template>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap class="my-3">
                            <v-flex class="flex-column flex-align-start px-3 grey--text text--darken-2 mb-3">
                              <h5 class="mt-3 mb-2 pf-font-16 font-weight-medium">Types of disabilities</h5>
                              <div class="flex-column flex-align-start" v-for="(disability, d) in disabilities" :key="d">
                                <v-radio-group :rules="[rules.required]" v-model="child.additional_info.disability.types[disability]" label="Access for registered families" class="required ma-0 pa-0">
                                  <div class="flex-row">
                                    <v-radio
                                      v-for="(type, j) in disabilityTypes"
                                      :key="j"
                                      :label="`${type}`"
                                      :value="type"
                                    ></v-radio>
                                  </div>
                                </v-radio-group>
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex class="button-container pr-0 text-xs-right hidden-xs-only">
                              <div class="d-inline-flex">
                                <v-btn class="pf-btn pf-btn-save" @click="changeDataTabs('tab-3')">
                                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                                  <div>Continue</div>
                                </v-btn>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>

                    <v-tab-item value="tab-3">
                      <v-card flat>
                        <v-card-text>
                          <v-layout wrap>
                            <v-flex sm6 class="flex-column flex-align-start grey--text text--darken-2">
                              <h5 class="my-1 pf-font-16 font-weight-medium">Profile image for {{ child.first_name || 'the child' }}</h5>
                              <img v-if="child.child_avatar" class="border-radius-15 my-2" width="200" :src="child.child_avatar.replace('/thumb/', '/original/')" />
                              <img v-else class="border-radius-15 my-2" width="200" src="/static/profile-pic.jpg" />
                            </v-flex>
                            <v-flex sm6 class="ma-3 flex-center margin-auto-15">
                                <v-btn
                                  v-if="child.id"
                                  flat
                                  class="pf-btn pf-text-teal"
                                  title="Upload Avatar"
                                  @click="addProfileImage(c)"
                                >
                                  <v-icon>file_upload</v-icon>
                                  Upload Avatar
                                </v-btn>
                                <p v-else>Please save the child data then upload the avatar</p>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>

                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-layout class="my-3 flex-column pl-2" id="common-tabs">
            <h5 class="mb-3 font-weight-bold">3. Preferences & Contact</h5>
            <v-tabs v-model="commonTabsModel" slider-color="#019d8c" class="px-2 pf-tabs-teal pf-tab pf-width-100p">

              <v-tab href="#tab-1">
                Preferences
                <v-icon class="pf-text-teal ml-1" size="20">how_to_reg</v-icon>
              </v-tab>
              <v-tab href="#tab-2">
                Contact
                <v-icon class="pf-text-teal ml-1" size="20">call</v-icon>
              </v-tab>

              <v-tab-item value="tab-1">
                <v-card flat>
                  <v-card-text>
                    <h5 class="mt-3 mb-2 ml-3 pf-font-16 font-weight-medium">Describe the family composition best suited for this child</h5>
                    <v-layout wrap class="my-3">
                      <v-flex xs12 sm4>
                        <v-select v-model="childDetails.preference.parent_type" label="Parent type (select all that apply)" class="px-3" multiple small-chips deletable-chips :items="parentTypes" @change="changedData"></v-select>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-select v-model="childDetails.preference.other_children" label="Other children" class="px-3" :items="otherChildren" @change="changedData"></v-select>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-select v-model="childDetails.preference.gender" label="Gender" class="px-3" :items="prefGenders" @change="changedData"></v-select>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-select v-model="childDetails.preference.age" label="Age" class="px-3" :items="prefAges" @change="changedData"></v-select>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-select v-model="childDetails.preference.religion" label="Religious preference" class="px-3" :items="prefReligions" @change="changedData"></v-select>
                      </v-flex>
                    </v-layout>

                    <v-layout>
                      <v-flex class="button-container pr-0 text-xs-right hidden-xs-only">
                        <div class="d-inline-flex">
                          <v-btn class="pf-btn pf-btn-save" @click="changeCommonTabs('tab-2')">
                            <v-icon size="16" class="pr-1">check_circle</v-icon>
                            <div>Continue</div>
                          </v-btn>
                        </div>
                      </v-flex>
                    </v-layout>

                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item value="tab-2">
                <v-card flat>
                  <v-card-text>
                    <h5 class="mt-3 mb-2 ml-3 pf-font-16 font-weight-medium">Agency</h5>
                    <v-layout wrap class="my-3">
                      <v-flex xs12 sm6 md4>
                        <!-- <v-autocomplete
                          label="Agency" 
                          class="required px-3"
                          item-text="name"
                          item-value="_id"
                          :items="[]"
                          :rules="rulesAgency"
                          v-model="childDetails.agency"
                          :disabled="session.role() !== 'admin'"
                          @change="changedData">
                        </v-autocomplete> -->
                        <span class="ml-4">{{ childDefaultAgency }}</span>
                      </v-flex>
                    </v-layout>
                    <h5 class="mt-3 mb-2 ml-3 pf-font-16 font-weight-medium">Contact Information</h5>
                    <v-layout wrap class="my-3">
                      <v-flex class="xs12 sm4">
                        <v-text-field 
                          label="Street Address Line 1" 
                          v-model.trim="childDetails.contactInfo.line_1"
                          class="pr-4 pl-4" 
                          @input="changedData">
                        </v-text-field>
                      </v-flex>
                      <v-flex class="xs12 sm4">
                        <v-text-field 
                          label="Street Address Line 2" 
                          v-model="childDetails.contactInfo.line_2" 
                          @input="changedData" 
                          class="pr-4 pl-4">
                        </v-text-field>
                      </v-flex>
                      <v-flex class="xs12 sm4">
                        <v-text-field 
                          label="City" 
                          class="pr-4 pl-4" 
                          v-model.trim="childDetails.contactInfo.city"
                          @input="changedData">
                        </v-text-field>
                      </v-flex>
                      <v-flex class="xs12 sm4">
                        <v-autocomplete
                          label="Country" 
                          class="pr-4 pl-4"
                          item-text="name"
                          item-value="id"
                          :items="Country" 
                          :rules="[rules.required]"
                          v-model="childDetails.contactInfo.country" 
                          @change="changedData($event, 'Country')">
                        </v-autocomplete>
                      </v-flex>
                      <v-flex class="xs12 sm4">
                        <v-autocomplete
                          label="State" 
                          :items="filteredData" 
                          item-value="id"
                          item-text="name"
                          no-data-text="No data available"
                          :rules="[rules.required]"
                          class="pr-4 pl-4 required" 
                          @change="changedData($event, 'State')" 
                          v-model="childDetails.contactInfo.state">
                        </v-autocomplete>
                      </v-flex>
                      <v-flex class="xs12 sm4">
                        <v-text-field 
                          label="Zip Code" 
                          v-mask="'#####'"
                          placeholder="#####"
                          v-model="childDetails.contactInfo.zip" 
                          class="pr-4 pl-4"
                          :rules="[rules.zipRules]"
                          @input="changedData">
                        </v-text-field>
                      </v-flex>
                      <!-- <v-flex class="xs12 sm4">
                        <v-text-field 
                          label="Email Address" 
                          v-model="childDetails.contactInfo.email" 
                          @blur="duplicateEmailChecking"
                          class="required pr-4 pl-4"
                          :rules="[rules.required, rules.emailRules]"
                          v-validate="'required'" 
                          data-vv-name="emailAddress" 
                          @input="changedData">
                        </v-text-field>
                      </v-flex>
                      <v-flex class="xs12 sm4">
                        <v-text-field 
                          v-mask="'(###) ###-####'"
                          placeholder="(###) ###-####"
                          label="Phone Number" 
                          v-model="childDetails.contactInfo.phone" 
                          @input="changedData" 
                          :rules="[rules.phoneRules]"
                          class="pr-4 pl-4">
                        </v-text-field>
                      </v-flex>
                      <v-flex class="xs12 sm4">
                        <v-text-field
                          label="Website URL"
                          hint="Ex: https://example.com, http://example.com"
                          v-model="childDetails.contactInfo.website"
                          class="pr-4 pl-4"
                          :rules="rules.websiteRules"
                          data-vv-name="websiteAddress"
                          @input="changedData">
                        </v-text-field>
                      </v-flex> -->
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>

            </v-tabs>
          </v-layout>

        </v-layout>

        <v-layout class="button-container pr-4 pl-4">
          <v-flex xs12 sm12 md12 v-if="isFormDataChanged" class="pr-0 text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>
/* global session store config */
/* eslint complexity: ["error", 22] */
import { mapGetters } from 'vuex';
import { create, getOne, getCollection, update, remove, validateUrl } from '../helpers/helpers';
import swal from 'sweetalert2';
import { mask } from 'vue-the-mask';
import Editor from '@tinymce/tinymce-vue';

export default {
  directives: { mask },
  components: {
    Editor
  },
  data: vm => ({
    config,
    childDetails: {},
    loading: false,
    parent1Dob: null,
    parent2Dob: null,
    dobFormatted: [],
    parent1DobFormatted: null,
    parent2DobFormatted: null,
    isFormDataChanged: false,
    nonEditedData: {},
    previousPetsList: [],
    childrenTypes: [
      { text: 'Individual', value: 'Individual' },
      { text: 'Sibling Group', value: 'Group' }
    ],
    enableMultiChild: false,
    form: {
      childType: {
        label: 'Child Type',
        defaultText: 'Individual',
        coupleText: 'Sibling Group',
        singleText: 'Sibling Group with Individual',
        value: false
      },
      waitingFor: {
        label: 'Waiting Since',
        value: ''
      },
      familyStructure: {
        label: 'Family Structure',
        value: ''
      },
      houseType: {
        label: 'Your House Type',
        value: ''
      },
      neighbourhood: {
        label: 'Your Neighbourhood',
        value: ''
      },
      pet: {
        label: 'Your Pets',
        value: ''
      },
      family: {
        label: 'Your Family',
        value: ''
      },
      generalInfoTitle: 'General Information',
      child: {
        title: 'Child',
        fields: {
          firstName: {
            label: 'First Name',
            value: '',
            rules: [
              v => !!v.trim() || 'First name is required'
            ]
          },
          lastName: {
            label: 'Last Name',
            value: '',
          },
          gender: {
            label: 'Gender',
            value: ''
          },
          dob: {
            label: 'Date of Birth',
            value: null,
            picker: false
          },
          ethinicity: {
            label: 'Ethinicity',
            value: ''
          },
          education: {
            label: 'Education',
            value: ''
          },
          religion: {
            label: 'Religion',
            value: ''
          },
          occupuation: {
            label: 'Occupation',
            value: ''
          }
        }
      },
    },
    ethnicities: [
      'Black/African American',
      'Asian',
      'White/Caucasian',
      'Hispanic/Latino',
      'American Indian/Alaskan Native',
      'Pacific Islander/Native Hawaiian',
      'Unable to determine'
    ],
    educations: [
      'Unknown',
      '1st Grade',
      '2nd Grade',
      '3rd Grade',
      '4th Grade',
      '5th Grade',
      '6th Grade',
      '7th Grade',
      '8th Grade',
      '9th Grade',
      '10th Grade',
      'Other'
    ],
    genders: [
      'Male',
      'Female',
      'Female to Male',
      'Male to Female',
      'In Transition',
      'Other',
      'Unknown'
    ],
    dataTabsModel: 'data-tabs-model',
    commonTabsModel: 'common-tabs-model',
    yesOrNo: [{ text: 'Yes', value: true }, { text: 'No', value: false }],
    languages: ['English', 'Spanish', 'Russian', 'French', 'None'],
    pets: ['Cats', 'Dogs', 'Other'],
    eligibilities: [
      'Ongoing financial assistance',
      'Ongoing medical assistance',
      'Ongoing mental health assistance',
      'Non-recurring adoption costs',
      'Check with child\'s worker'
    ],
    parentTypes: ['2 parents', '1 female parent', '1 male parent'],
    otherChildren: ['No preference', 'No other children', 'Must have other children'],
    prefGenders: ['No preference', 'Male only', 'Female only'],
    prefAges: ['No preference', 'Must be oldest', 'Must be youngest'],
    prefReligions: [
      'Anglican',
      'Atheist',
      'Bahai',
      'Baptist',
      'Buddhist',
      'Catholic',
      'Christian',
      'Church of Christ',
      'Episcopal',
      'Hindu',
      'Jewish',
      'Lutheran',
      'Mormon',
      'Methodist',
      'Muslim',
      'None',
      'Non-denominational',
      'Other',
      'Presbyterian',
      'Protestant',
      'The Church of Jesus Christ of Latter-Day Saints',
      'Unitarian'
    ],
    disabilityAccess: ['Do not display any information about disabilities or risk factors', 'Display only the overall levels without specific details', 'Display everything, overall levels and specific details'],
    risks: ['Alcohol exposed', 'Domestic-violence exposed', 'Drug exposed—in home', 'Failure to thrive', 'History of abuse or neglect', 'History of multiple placements', 'Intellectual disability in birth family', 'Mental illness in birth family', 'Premature birth', 'Schizophrenia in birth family', 'Sexual abuse'],
    disabilities: [
      'Overall level of physical disability',
      'Overall level of emotional disability',
      'Overall level of behavioral disability',
      'Overall level of developmental disability',
      'Overall level of learning disability'
    ],
    disabilityTypes: ['None', 'Mild', 'Moderate', 'Severe'],
    rules: {
      required: value => !!value || 'Field is required.',
      blankRules: (v) => !!v && v.trim().length > 0 || 'Field is required',
      emailRules: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(v) || 'Please enter valid email address',
      zipRules: (v) => v === undefined || v === '' || /^([0-9]{5}|[0-9]{6})(?:-[0-9]{4})?$/.test(v) || 'Please enter valid zip code',
      phoneRules: (v) => v === undefined || v === '' || /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number',
      websiteRules: [
        (v) => v === undefined || v === '' || (validateUrl(v)) || 'Please enter valid URL',
        v => !v || vm.checkIfNoPFUrl(v) || 'The entered URL is not valid for campaigns'
      ]
    },
    editorOption: {
      placeholder: 'Add Letter Content Here..',
    },
    aboutContent: '',
    init: {
      height: 300,
      selector: 'blogTextEditor',
      placeholder: 'Add about child(ren) here',
      menubar: true,
      plugins: ['advlist autolink lists link charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime table paste code help wordcount emoticons'],
      toolbar:
           'undo redo | bold italic backcolor | fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | forecolor backcolor removeformat | pagebreak | charmap emoticons | preview | template link anchor codesample | ltr rtl'
    },
    rulesName: [
      v => !!v || 'Group name is required'
    ],
    rulesAgency: [
      v => !!v || 'Agency is required'
    ],
    membershipRules: [
      v => !!v || 'membership is required'
    ],
    panels: [],
    siblingIndex: -1,
    childAgency: null
  }),
  computed: {
    ...mapGetters(['Child']),
    childDefaultAgency () {
      return this.childAgency && this.childAgency.name ? this.childAgency.name : 'Not found';
    },

    filteredData () {
      let countryId = this.childDetails.contactInfo && this.childDetails.contactInfo.country && typeof this.childDetails.contactInfo.country === 'object' ? this.childDetails.contactInfo.country.id : (this.childDetails.contactInfo.country ? this.childDetails.contactInfo.country : null);
      let options = this.State;
      return countryId ? options.filter(o => o.country.id === countryId) : [];
    },
    states () {
      return this.State.filter(o => o.country.id === '5f0af2eb1b61360afbb1aa0c');
    },
    Country: {
      get () {
        return store.state.Country;
      },
      set (value) {
        store.commit('setCountry', value);
      }
    }, 
    State: {
      get () {
        return store.state.State;
      },
      set (value) {
        store.commit('setState', value);
      }
    },
    Child: {
      get () {
        return store.state.Child;
      },
      set (value) {
        store.commit('setChild', value);
      }
    },
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    },
    /* AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    }, */
  },
  watch: {
    childDetails: {
      handler: function (after, before) {
        let self = this;
        after.human.map((x, i) => {
          self.dobFormatted[i] = self.formatDate(x.birth_date);
          return x;
        });
      },
      deep: true
    }
  },
  async created () {
    this.initialize();
    this.initializeCountry();
    this.initializeState();
    this.fetchDefaultAgency();
  },
  mounted () {
    window.getApp.$on('NEW_ALBUM_PHOTO', messageEvent => {
      this.isListEmpty = false;
      console.log('------------>>>>>>>', 'Album Photo', messageEvent);
      if (messageEvent.data) {
        let albumId = messageEvent.data.album;
        let newImages = messageEvent.data;
        if (this.Child.avatar_album === albumId) {
          if (newImages.filename && newImages.filename.indexOf('_siblingavatar_') > -1) {
            /* Update the human.child_avatar */
            let childHumanId = newImages.original_url.split('/')[1];
            let humanIndex = this.childDetails.human.findIndex(x => x.id.toString() === childHumanId);
            if (humanIndex > -1) {
              this.childDetails.human[humanIndex].child_avatar = newImages.thumb_url;
              if (!this.childDetails.avatar || this.childDetails.avatar === '') {
                this.childDetails.avatar = newImages.thumb_url;
              }
              this.Child = this.childDetails;
            }
          }
        }
      }
    });
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    initialize () {
      this.childDetails = JSON.parse(JSON.stringify(this.Child));
      this.enableMultiChild = this.childDetails.child_type === 'Group';

      let self = this;
      this.childDetails.human = this.childDetails.human.map((x, i) => {
        /* Update the panel expand */
        this.panels.push(i ? false : true);

        // let date = self.formatDate(x.birth_date);
        x.birth_date = x.birth_date.substr(0, 10);

        this.dobFormatted.push(this.formatDate(x.birth_date));
        if (!x.additional_info) {
          x.additional_info = {};
        }

        if (!x.additional_info.jurisdiction) {
          x.additional_info.jurisdiction = {
            state: '',
            county: ''
          };
        }
        if (!x.additional_info.disability) {
          x.additional_info.disability = {
            display: 'Do not display any information about disabilities or risk factors',
            risks: [],
            types: {
              'Overall level of physical disability': 'None',
              'Overall level of emotional disability': 'None',
              'Overall level of behavioral disability': 'None',
              'Overall level of developmental disability': 'None',
              'Overall level of learning disability': 'None',
            }
          };
        }
        return x;
      });

      if (!this.childDetails.preference) {
        this.childDetails.preference = {
          parent_type: [],
          other_children: 'No preference',
          gender: 'No preference',
          age: 'No preference',
          religion: 'None',
        };
      }
      if (!this.childDetails.contactInfo) {
        this.childDetails.contactInfo = {
          line_1: '',
          line_2: '',
          country: { id: '5f0af2eb1b61360afbb1aa0c' },
          phone: '',
          city: '',
          state: '',
          zip: '',
          email: '',
          website: ''
        };
      }
    },
    async fetchDefaultAgency () {
      if (this.Child.default_agency) {
        let sort = { name: 1 };
        let { error, data } = await getOne('Agency', this.Child.default_agency, '', 'name');
        if (error) {
          console.log(error);
        } else {
          if (data) {
            this.childAgency = data;
          }
        }
      }
    },
    async initializeCountry () {
      if (!this.Country.length) {
        let sort = { name: 1 };
        let { error, data } = await getCollection('Country', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Country = data;
          }
        }
      }
    },
    async initializeState () {
      if (!this.State.length) {
        let sort = { name: 1 };
        let { error, data } = await getCollection('State', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.State = data;
          }
        }
      }
    },
    changeDataTabs (id) {
      if (id) {
        this.dataTabsModel = id;
        window.getApp.$vuetify.goTo(document.getElementById('expansion-panel'));
      }
    },
    changeCommonTabs (id) {
      if (id) {
        this.commonTabsModel = id;
        window.getApp.$vuetify.goTo(document.getElementById('common-tabs'));
      }
    },

    // eslint-disable-next-line complexity
    async save () {
      if (this.isFormDataChanged && this.$refs.childInfoForm.validate()) {

        let isError = false;

        for (let i = 0; i < this.childDetails.human.length; i++) {

          let human = JSON.parse(JSON.stringify(this.childDetails.human[i]));

          // human.ethnicity = human.ethnicity || '';
          human.education = human.education || '';
          human.religion = human.religion || '';

          if (human && human.id) {
            if (this.childDetails.child_type === 'Individual' && i > 0) {
              /* Remove the human - less chance */
              let { error: removeError, data: removeData, status: removeStatus } = await remove('Human', human.id);
              if (removeError) {
                console.log('removeError', removeError);
                isError = true;
              } else {
                this.childDetails.human.splice(i, 1);
              }
            } else {
              let { error: updateError, data: updateData, status: updateStatus } = await update('Human', human, human.id);
              if (updateError) {
                console.log('updateError', updateError);
                isError = true;
              } else {
                this.childDetails.human[i] = updateData;
              }
            }
          } else {
            /* Create the human */
            human.child = this.childDetails.id;
            let { error: createError, data: createData, status: createStatus } = await create('Human', human);
            if (createError) {
              console.log('createError', createError);
              isError = true;
            } else {
              this.childDetails.human[i] = createData;
            }
          }

          if (i === 0) {
            this.childDetails.religion = [];
          }
          if (this.childDetails.child_type !== 'Individual') {
            if (human.religion) {
              this.childDetails.religion.push(human.religion);
            }
          }
        }

        if (this.childDetails.child_type === 'Individual') {
          this.childDetails.name = this.childDetails.human[0].first_name;
          this.childDetails.religion = this.childDetails.human[0].religion ? [this.childDetails.human[0].religion] : [];
        }

        // Update the account
        this.Child = this.childDetails;
        this.Child.updated_from = 'childInfo';
        let updatePayload = JSON.parse(JSON.stringify(this.Child));
        updatePayload.human = updatePayload.human.map(x => x._id);

        let childUpdate = await update('Child', updatePayload, session.getSession().adminUser ? session.getSession().user.human.child.id : 'Me');
        let error = childUpdate.error;
        let data = childUpdate.data;
        let status = childUpdate.status;
        if (error) {
          console.log('error', error);
          isError = true;
        }
        // Show the resultant response to the user
        if (isError) {
          this.isFormDataChanged = true;
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Unable to save your data, please try again.'
          };
        } else {
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Child information updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.isFormDataChanged = false;
              store.commit('setChild', data);
              this.initialize();
            }
          });
        }
      } else if (!this.$refs.childInfoForm.validate()) {
        swal.fire({
          type: 'warning',
          title: 'Incomplete',
          text: 'Please make sure you filled all the mandatory fields for all the children',
          timer: 2500,
          onClose: () => {
            return;
          }
        });
      }
    },
    hideButtons () {
      this.isFormDataChanged = false;
      this.initialize();
    },
    formatDate (date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate (date) {
      if (!date) return '';
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    changedChildType (childType) {
      this.isFormDataChanged = true;
      if (['Group'].indexOf(childType) > -1) {
        if (this.childDetails.human.length === 1) {
          this.childDetails.human.push({
            birth_date: '',
            education: '',
            ethnicity: '',
            first_name: '',
            gender: 'Unknown',
            last_name: '',
            case_id: '',
            occupation: '',
            religion: ''
          });
        }
        this.enableMultiChild = true;
      } else {
        if (this.childDetails.human.length > 1) {
          this.childDetails.human = [this.childDetails.human[0]];
        }
        this.enableMultiChild = false;
      }
    },
    addChild () {
      if (this.$refs.childInfoForm.validate()) {
        this.childDetails.human.push({
          first_name: '',
          middle_name: '',
          last_name: '',
          case_id: '',
          ethnicity: '',
          education: '',
          birth_date: '',
          gender: 'Unknown',
          additional_info: {
            legally_free: true,
            icwa: false,
            keep_relationships: false,
            pets: [],
            assistance_eligibility: [],
            smoke_allergy: false,
            jurisdiction: { state: '', county: '' },
            primary_language: '',
            secondary_language: '',
            keep_relation_person: '',
            about: '',
            pay_private_services: 'Check with child\'s worker',
            allergies: '',
            disability: {
              display: 'Do not display any information about disabilities or risk factors',
              risks: [],
              types: {
                'Overall level of physical disability': 'None',
                'Overall level of emotional disability': 'None',
                'Overall level of behavioral disability': 'None',
                'Overall level of developmental disability': 'None',
                'Overall level of learning disability': 'None',
              }
            }
          },
          picker: false
        });
        /* Change the child type */
        if (this.childDetails.human.length === 1) {
          this.childDetails.child_type = 'Individual';
        } else {
          this.childDetails.child_type = 'Group';
        }
        this.panels = this.panels.map(x => false);
        this.panels.push(true);
        this.dataTabsModel = 'tab-1';
      }
    },
    removeChild (index) {
      if (index > -1 && this.childDetails.human[index]) {
        this.childDetails.human.splice(index, 1);
      }
      if (this.childDetails.human.length === 1) {
        this.childDetails.child_type = 'Individual';
        this.enableMultiChild = false;
      }
    },
    isBasicInfoCompleted (child) {
      if (!child) {
        return false;
      }
      if (!child.first_name || !child.birth_date || !child.gender || !child.ethnicity) {
        return false;
      }
      let metaData = child.additional_info ? child.additional_info : null;
      if (!metaData || !metaData.jurisdiction || !metaData.jurisdiction.state || typeof metaData.legally_free === 'undefined' || !metaData.primary_language) {
        return false;
      }
      return true;
    },
    changedData (event, changedList = 'None') {
      if (changedList === 'Country') {
        this.childDetails.contactInfo.state = '';
      }
      this.isFormDataChanged = true;
    },
    addProfileImage (childIndex = -1) {
      if (childIndex === -1) {
        return;
      }
      this.siblingIndex = childIndex;
      const client = global.filestack.init(config.filestack.client);
      const humanId = this.childDetails.human[this.siblingIndex].id;
      if (!humanId) {
        swal.fire({
          type: 'warning',
          title: 'Save the child',
          text: 'Please save the child data first then upload the avatar',
          timer: 2500,
          onClose: () => {
            return;
          }
        });
        return;
      }
      let albumId = this.Child.avatar_album;
      const options = {
        fromSources: ['local_file_system'],
        maxFiles: 1,
        accept: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
        uploadInBackground: false,
        transformations: {
          crop: { aspectRatio: 300 / 228, force: true }
        },
        storeTo: {
          location: 'S3',
          path: '/' + config.s3Domain + '/' + humanId + '/avatar/' + albumId + '/original/',
          access: 'public'
        },
        onFileSelected (file) {
          let filenameArr = file.filename.split('.');
          let ext = filenameArr.pop();
          let filename = filenameArr.join('.');
          filename = filename.replace(/[^0-9a-z]/gi, '');
          if (filename.indexOf('_siblingavatar_') > -1) {
            filename = filename.replace('_siblingavatar_', '');
          }
          return { name: filename + '_siblingavatar_' + (new Date().getTime()) + '.' + ext };
        },
        onUploadDone: (response) => {
          let self = this;
          if (response.filesUploaded && response.filesUploaded.length) {
            let original_url = config.s3BucketPath + response.filesUploaded[0].key;
            // let avatarThumb = original_url.replace('/original/', '/thumb/');
            let avatarThumb = original_url;
            // After uploading
            // $('.avatar').css('background', 'url(/static/loading_temp.gif) 50% 50% / cover no-repeat');
            /* Update the human.child_avatar */
            if (self.siblingIndex > -1) {
              self.childDetails.human[self.siblingIndex].child_avatar = avatarThumb;
              self.Child = self.childDetails;
            }
          }
        },
        
      };
      client.picker(options).open();
    },
  }
};
</script>

<style lang="css" scoped>

  .button-container{
    min-height: 60px;
  }
  .account-type{
    padding-top: 2px;
  }
  .switch-account{
    padding-top: 5px;
  }

  .switch-cover {
    cursor: pointer;
    float:left;
  }
  .switch-cover input {
      position: absolute;
      opacity: 0;
  }
  .checkmark {
      background-color: #eff0f4;
      padding: 6px 20px;
  }
  .switch-cover:hover input ~ .checkmark {
    background-color: #ccc;
  }
  .switch-cover input:checked ~ .checkmark {
    background-color: #019d8c;
    color: #fff;
  }
  .switch-cover input:checked ~ .checkmark:after {
    display: block;
  }
  @media(max-width:410px){
    .switch-account{
      padding-right: 0 !important;
      width: 100%;
      padding-bottom: 15px;
    }
    .pf-btn{
      min-width: 85px;
    }
  }
  @media(min-width: 600px) and (max-width:699px){
    .switch-account{
      padding-right: 0 !important;
      width: 100%;
      padding-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ChildInfo.vue